import api, { ApiResponse } from "./api";
import { PaymentMethod } from "../types/paymentMethod";
import { PaymentHistory } from "../types/paymentHistory";

const API_URL = "v1/stripe/payment/";

class PaymentService {
    async createSession(uid: number) {
        const response = await api
            .post(API_URL + "setup/session/create", {
                uid
            })
            .then((response: ApiResponse) => {
                if (response.data.c === 1) {
                    return response.data.v.id;
                }
                return "";
            })
            .catch(() => "");
        
        return response;
    }

    async getCard(uid: number) {
        const response = await api
            .post(API_URL + "card/get", {
                uid
            })
            .then((response: ApiResponse) => {
                if (response.data.c === 1) {
                    const data = response.data.v;
                    return new PaymentMethod(data.last4, data.expMonth, data.expYear, data.brand);
                }
                return null;
            })
            .catch(() => null);
        
        return response;
    }

    async queryHistory(uid: number, pageIndex: number) {
        const response = await api
            .post(API_URL + "history/query", {
                uid,
                pageIndex
            })
            .then((response: ApiResponse) => {
                if (response.data.c === 1) {
                    return new PaymentHistory(response.data.v.totalRecords, response.data.v.records);
                }
                return null;
            })
            .catch(() => null);
        
        return response;
    }
}

const paymentService = new PaymentService();

export default paymentService;
